import type { ComponentProps } from 'react'

type TextButtonProps = Omit<ComponentProps<'button'>, 'className'>

/** The quiet underlined action, styled as TextLink is, for something that acts rather than navigates. */
export function TextButton({ type = 'button', ...props }: TextButtonProps) {
  return (
    <button
      {...props}
      type={type}
      className="rounded-sm text-sm text-ink underline underline-offset-2 outline-none transition hover:text-brand focus-visible:ring-2 focus-visible:ring-brand-ring"
    />
  )
}
